import {
  fetchCertainPaymentMethod,
  setBonusCode,
} from '@cashier/cashier-data-access';

export const bonusCodeMiddleware =
  (store: any) => (next: any) => (action: any) => {
    const {
      cashierConfiguration: { activeType },
      customerInformation: { bonusCode },
      paymentMethods: {
        paymentMethod: { id },
      },
    } = store.getState();

    const result = next(action);

    if (action.type === setBonusCode.toString()) {
      if (bonusCode !== action.payload) {
        store.dispatch(
          fetchCertainPaymentMethod({
            type: activeType,
            id,
            bonusCode: action.payload,
          }),
        );
      }
    }

    return result;
  };
